import { Outlet } from 'react-router-dom';

import usePageViewTracks from 'lib/analytics/use-page-view-tracks';

export default function Home() {
	usePageViewTracks();

	return <Outlet />;
}
